import { Box, Button, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { PromoDropdown } from "../../CreateNewPromodeod/Components/PromoDropdown";
import { PromotionDropdownItems } from "../../../Helper";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { SecInputStyles } from "../../CreateNewPromodeod/View/CreatePromoCode";
import { Dayjs } from "dayjs";
import TuneIcon from "@mui/icons-material/Tune";
import { useGetAllPromoCodes } from "../../../store/Apis/StripeApi";

interface PromoFilterProps {
  searchValue: string;
  toggleDropdown: () => void;
  dropdownOpen: boolean;
  setPromoCodesData: (array: any) => void;
}
export const PromoFilter = ({
  searchValue,
  toggleDropdown,
  dropdownOpen,
  setPromoCodesData,
}: PromoFilterProps) => {
  const [selectedStatusItem, setSelectedStatusItem] = useState("");
  const [selectedPromotionItem, setSelectedPromotionItem] = useState("");
  const [selectedDate, setSelectedDate] = useState<Dayjs | null>(null);
  const dropdownItems = ["Expired", "Active"];
  const {
    mutate: FilterPromoCodesRequest,
    isPending,
    isSuccess,
    data: PromoCodesData,
  } = useGetAllPromoCodes();

  useEffect(() => {
    if (PromoCodesData) {
      setPromoCodesData(PromoCodesData);
    }
  }, [PromoCodesData]);

  const handleSelectStatusItem = (item: string) => {
    setSelectedStatusItem(item);
  };

  const handleSelectPromotionItem = (item: string) => {
    setSelectedPromotionItem(item);
  };

  const handleDateChange = (newDate: Dayjs | null) => {
    setSelectedDate(newDate);
  };

  const handleApplyFiltrationBtn = () => {
    let FilterRequestData = {
      code: searchValue ? searchValue : undefined,
      status: selectedStatusItem
        ? dropdownItems.indexOf(selectedStatusItem)
        : undefined,
      created: selectedDate ? selectedDate : undefined,
      promotionType: selectedPromotionItem
        ? PromotionDropdownItems.indexOf(selectedPromotionItem)
        : undefined,
    };
    FilterPromoCodesRequest(FilterRequestData);
    toggleDropdown();
  };

  const handleResetFiltrationBtn = () => {
    setSelectedStatusItem("");
    setSelectedPromotionItem("");
    setSelectedDate(null);
    FilterPromoCodesRequest({});
    toggleDropdown();
  };

  return (
    <Box>
      <Dropdown show={dropdownOpen} autoClose="outside">
        <Dropdown.Toggle
          className="bg-transparent border-0"
          onClick={toggleDropdown}
        >
          <TuneIcon
            sx={{ color: dropdownOpen ? "#12B6EA" : "var(--Main_icons_color)" }}
          />
        </Dropdown.Toggle>
        <Dropdown.Menu
          className={`promoCode ${
            dropdownOpen ? "promo-filter-menu show" : "promo-filter-menu"
          }`}
        >
          <Dropdown.Header>
            <Typography className="filter-title">Filter </Typography>
          </Dropdown.Header>
          <Box className="menu-body" sx={{ width: "100%" }}>
            <Box
              className="promo-filter-by-status"
              sx={{ marginBottom: "1rem" }}
            >
              <Typography className="filter-title">Status</Typography>
              <Box className="status-filter">
                <PromoDropdown
                  width="100%"
                  selectedItem={selectedStatusItem}
                  handleSelect={handleSelectStatusItem}
                  defaultRenderValue="Status"
                  dropdownItems={dropdownItems}
                />
              </Box>
            </Box>
            <Box
              className="promo-filter-by-promotion"
              sx={{ marginBottom: "1rem" }}
            >
              <Typography className="filter-title">Promotion Type</Typography>
              <Box className="status-filter">
                <PromoDropdown
                  width="100%"
                  selectedItem={selectedPromotionItem}
                  handleSelect={handleSelectPromotionItem}
                  defaultRenderValue="Select value"
                  dropdownItems={PromotionDropdownItems}
                />
              </Box>
            </Box>
            <Box className="promo-filter-by-date" sx={{ marginBottom: "1rem" }}>
              <Typography className="filter-title">Date</Typography>
              <Box className="status-filter">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer
                    components={["SingleInputDateRangeField"]}
                    sx={{ width: "100%" }}
                  >
                    <DatePicker
                      value={selectedDate}
                      onChange={handleDateChange}
                      sx={{
                        ...SecInputStyles,
                        width: "100%",
                        "& .MuiInputAdornment-root .MuiSvgIcon-root": {
                          color: "var(--Main_icons_color)",
                        },
                      }}
                    />
                  </DemoContainer>
                </LocalizationProvider>
              </Box>
            </Box>
            <Box className="promo-filter-actions">
              <Typography
                className="promo-reset-filter"
                onClick={handleResetFiltrationBtn}
              >
                Reset
              </Typography>
              <Box onClick={handleApplyFiltrationBtn}>
                <Button
                  className="create-promo-btn"
                  variant="contained"
                  sx={{ width: "100%", textTransform: "inherit" }}
                >
                  Apply filter
                </Button>
              </Box>
            </Box>
          </Box>
        </Dropdown.Menu>
      </Dropdown>
    </Box>
  );
};
